<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <path id="v5f43ptyqa" d="M0 0L14.666 0 14.666 11.6 0 11.6z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g transform="translate(-157 -724) translate(127 490) translate(16 66) translate(0 50) translate(14 118) translate(1 1)">
                    <mask id="5yge4dumwb" fill="#fff">
                      <use xlink:href="#v5f43ptyqa" />
                    </mask>
                    <path
                      fill="#13A2E8"
                      d="M8.25 11.6l5.342-5.341c.663-.663 1.074-1.58 1.074-2.593C14.666 1.642 13.024 0 10.999 0h-.916v1.833h.916c1.01 0 1.834.822 1.834 1.833 0 .49-.191.95-.537 1.297L7.333 9.926 2.37 4.963c-.347-.346-.537-.808-.537-1.297 0-1.011.821-1.833 1.833-1.833h.917V0h-.917C1.642 0 0 1.642 0 3.666c0 1.014.411 1.93 1.074 2.593L6.416 11.6h1.833z"
                      mask="url(#5yge4dumwb)"
                    />
                  </g>
                  <path
                    fill="#13A2E8"
                    d="M19.249 9.167c-.507 0-.916-.411-.916-.917s.41-.917.916-.917c.507 0 .917.411.917.917s-.41.917-.917.917m0-3.667c-1.52 0-2.75 1.233-2.75 2.75s1.23 2.75 2.75 2.75 2.75-1.233 2.75-2.75-1.23-2.75-2.75-2.75"
                    transform="translate(-157 -724) translate(127 490) translate(16 66) translate(0 50) translate(14 118) translate(1 1)"
                  />
                  <path
                    fill="#164194"
                    d="M19.249 11c-.322 0-.63-.058-.916-.16v6.577c0 1.519-1.232 2.75-2.75 2.75l-4.584-.001c-1.519 0-2.75-1.231-2.75-2.75V11.6H6.416v5.815c0 2.531 2.052 4.583 4.583 4.583l4.584.001c2.531 0 4.583-2.052 4.583-4.583V10.84c-.287.102-.595.16-.917.16"
                    transform="translate(-157 -724) translate(127 490) translate(16 66) translate(0 50) translate(14 118) translate(1 1)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>